import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import Modal from "components/Modal";
import { TextArea, Select } from "components/form";
import { useCore } from "store/core";
import cleanObject from "utils/editHelper";
import { CkEditor } from "components/form";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const types = [
  { label: "لیگ", value: "League" },
  { label: "خبر", value: "News" },
  // { label: "ویدیو", value: "Video" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;
  const { sidebar } = item;
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(sidebar);
  }, [sidebar]);
  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            ...transformTranslateServerValues(item),
          }}
          onSubmit={async (values, { setSubmitting }) => {
            if (!values.parent_id) {
              delete values.parent_id;
            }

            const clean = cleanObject(values, [
              "id",
              "updatedAt",
              "uuid",
              "createdAt",
            ]);

            await props.submit(clean, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  {/* <Field
                             label="والد"
                             name="parent_id"
                             component={Select}
                             options={
                               [
                                 { value: null, label: "بدون والد" },
                                 ...core.productCategories,
                               ] || []
                             }
                             validate={(value) => validationWrapper(value)}
                           /> */}
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.title"
                    component={TextFieldSlug}
                    slugFieldName="translations.fa.slug"
                  />
                  <Field
                    placeholder="name"
                    label="نام انگلیسی :"
                    name="translations.en.title"
                    component={TextFieldSlug}
                    slugFieldName="translations.en.slug"
                  />
                </div>

                <div className="intro-y">
                  <Field
                    label="نوع :"
                    name="type"
                    component={Select}
                    options={types}
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>

                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  <div className="intro-y">
                    <Field
                      label="نامک:"
                      name="translations.fa.slug"
                      component={TextField}
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="نامک انگلیسی:"
                      name="translations.en.slug"
                      component={TextField}
                    />
                  </div>
                </div>
                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  <Field
                    label="خلاصه"
                    name="translations.fa.summary"
                    component={TextArea}
                  />
                  <Field
                    label="خلاصه انگلیسی"
                    name="translations.en.summary"
                    component={TextArea}
                  />
                  {/* <Field
                             label="ترتیب"
                             name="order"
                             type="number"
                             component={TextField}
                             
                           /> */}

                  <div className="w-full mt-5 mb-5 flex items-center gap-2">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <Field
                        type="checkbox"
                        name="sidebar"
                        id="sidebar"
                        className="sr-only peer"
                        onClick={handleToggle}
                      />
                      <div
                        className={`w-9 h-5 rounded-full transition-colors duration-300 ease-in-out ${
                          isChecked ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-300 ease-in-out ${
                            isChecked
                              ? "translate-x-[calc(100%-2.125rem)]"
                              : "translate-x-0.4"
                          }`}
                        ></div>
                      </div>
                    </label>
                    <label
                      htmlFor="sidebar"
                      className="text-xs text-gray-600 cursor-pointer select-none font-bold"
                    >
                      نمایش در سایدبار
                    </label>
                  </div>
                </div>

                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                  <div className="intro-y">
                    <Field
                      label="توضیحات:"
                      name="translations.fa.content"
                      component={CkEditor}
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="توضیحات انگلیسی:"
                      name="translations.en.content"
                      component={CkEditor}
                    />
                  </div>
                </div>

                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="تصویر"
                      name="media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                  {/* <div className="w-5/12">
                             <Field
                               label="Image"
                               name="_en*media_id*media"
                               dataType="id"
                               component={GalleryField}
                             />
                           </div> */}
                </div>

                {/* <div>
                           {core.slidersLoad ? (
                             <Loading />
                           ) : (
                             <Field
                               label="اسلایدر :"
                               name="slider_id"
                               valueOnly
                               component={Select}
                               options={core.sliders || []}
                             />
                           )}
                         </div> */}
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
